import { useContext, useEffect, useState } from "react"
import { AlertContext } from "../../../providers/alert.provider"
import { NavLink, useNavigate, useParams } from "react-router-dom"
import { empty } from "../../../helpers/util.helper"
import { IResponse } from "../../../interfaces/response.interface"
import { CpvBlockHeader, CreateButtonBlock, FormSubmitButtonsBlock } from "../../../components/ui/blocks"
import { InputLabel, MenuItem, Select, TextField, TextareaAutosize } from "@mui/material"
import { onChangeEventHelper } from "../../../helpers/form"
import { DispositionStatusEnum, DispositionTypeEnum } from "../../../enums/disposition.enum"
import { DispositionDestinationForm, GroupCheckBoxesComponent } from "./form-desination"
import { UserToolGridMenuComponent } from "../../../components/user-tools/grid-menu.tsx"
import { BootStrapSpinner } from "../../../components/ui/views/spinner/index.tsx"
import { dispositionIsEditableHelper } from "../helpers/index.tsx"
import { 
    DispositionCreateService,
    DispositionDeleteAnimalsService,
    DispositionDeleteAnimalMultiService,
    DispositionGetAnimalsSearchService,
    DispositionGetAnimalsService,
    DispositionUpdateService
} from "../../../services/disposition.service"
import { AlertBase } from "../../../components/ui/views/alerts/index.tsx"
import { FasFaLock } from "../../../components/ui/fontawesome/index.tsx"
import { environment } from "../../../environmentals/config.tsx"
import { DispositionContext } from "../provider.tsx"
import IComponentState, { ComponentStateReadyDto } from "../../../interfaces/component-state.interface"
import TemplatesCattleProofCenterBlock from "../../../templates/cattleproof/center-block"
import AnimalTableEditorComponent from "../../../components/user-tools/animal-table"
import EditOffIcon from '@mui/icons-material/EditOff'
import OutputIcon from '@mui/icons-material/Output'
import UiNotificationsAlertsComponent from "../../../components/ui/notifications/alerts.component.tsx"
import AlertBox from "../../../components/upload/alert.tsx"

export const DispositionForm = ({ groups, backButtonEvent }: any) => {
    const [ formData, setFormData ] = useState<any>({})
    const [ toggle, setToggle ] = useState<boolean>(false)
    const [ animalState ] = useState<IComponentState<any>>(ComponentStateReadyDto)
    const [ animalRows, setAnimalRows ] = useState<any[]>([])

    const { setMsg, setType, setAutoClose } = useContext(AlertContext);
    const { disposition, setDisposition, dispositionState, refreshDisposition } = useContext(DispositionContext);
    const { gid } = useParams();
    const nav = useNavigate();
    const state = dispositionState;

    const getAnimals = () => DispositionGetAnimalsService(formData.ID)
    
    const searchAnimals = (search?: string) => DispositionGetAnimalsSearchService(formData.ID || '', search)

    const deleteAnimal = (row: any) => {
        return DispositionDeleteAnimalsService(formData.ID || '', row.hid).then((r) => {
            setFormData(r.data);
            getAnimals().then(r => {
                setAnimalRows(r.data);
                refreshDisposition();
            })
        })
    }

    const onSubmitEvent = (e: any) => {
        e.preventDefault();
        const doAction = (!empty(formData?.ID))? 'update' : 'create';
        const action = (doAction === 'create')? DispositionCreateService(formData) : DispositionUpdateService(formData);
        action.then((r: IResponse<any>) => {
            if(r.success) {
                setFormData(r.data);
                setDisposition(r.data);
                setType(true);
                setMsg('Saved successfully.');
                if(doAction === 'create')
                    nav(`/disposition/${r.data?.group?.ID}/`);
                else
                    refreshDisposition();
                //backButtonEvent()
            } else {
                setMsg(r.error || 'An error occurred.');
                setType(false);
            }
            setAutoClose(5000)
        })
    }

    const onSubmitMultiDeleteEvent = (body: string[], func?: (r: IResponse<any>) => void) => {
        DispositionDeleteAnimalMultiService(formData?.ID, body).then((r: IResponse<any>) => {
            if(func) {
                func(r);
            }
            if(r.success) {
                setMsg('Successfully deleted');
                setType(true);
                refreshDisposition();
            } else {
                setMsg(r.error);
                setType(false);
            }
        });
    }        

    const readOnly: boolean = formData?.status? !dispositionIsEditableHelper(formData?.status) || formData?.assigned?.length > 0 : false

    const hasAnimalsInGroup: boolean = formData?.herd || 0 > 0;

    useEffect(() => {
      setFormData(disposition || {});
    }, []);

    return (
        state.ready?
        <TemplatesCattleProofCenterBlock>
            { toggle?
                <AnimalTableEditorComponent
                    locked={ readOnly }
                    ready={ animalState.ready }
                    rows={ animalRows }
                    setRows={ setAnimalRows }
                    submitEvent={ () => {} }
                    backButtonEvent={ () => {
                        refreshDisposition();
                        setToggle(false);
                    } }
                    onSubmitMultiDeleteEvent={ onSubmitMultiDeleteEvent }
                    columns={[
                        { field: 'group_name', headerName: 'Group Name', flex: 1, minWidth: 250, editable: false },
                        { field: 'pct', headerName: 'PCT', flex: 1, minWidth: 250, editable: false },
                        { field: 'non_pct', headerName: 'Non-PCT', flex: 1, minWidth: 250, editable: false },
                        {
                            field: 'archived_at',
                            cellClassName: 'justify-content-center',
                            headerName: 'Disposed',
                            minWidth: 50,
                            editable: false,
                            renderCell: e => e.row?.archived_at? <OutputIcon style={{color: 'red'}} /> : ''
                        },
                        { field: 'action', headerName: '', cellClassName: 'justify-content-end', width: 100, flex: 1, editable: false, renderCell: (e: any) => {
                            return readOnly? <EditOffIcon /> : <UserToolGridMenuComponent deleteEvent={ () => deleteAnimal(e.row) } />
                        }},
                    ]}
                    onLoadEvent={ getAnimals }
                    submitSearch={ searchAnimals }
                />
                :
                gid === 'create' || state.ready? 
                <form action="#" onSubmit={ onSubmitEvent }>
                    { readOnly && <AlertBase text={ `This Disposition Group is currently ${formData.type === DispositionTypeEnum.transport? 'disposed'  : 'being used in the Marketplace'} and can not be edited` } type="info" icon={<FasFaLock />} /> }
                    <CpvBlockHeader
                        title={ `${gid === 'create'? 'Create a' : readOnly? 'Edit' : 'View'}  disposition group for transport or sale` }
                    >
                        <div className="col-count- gapped">
                            <TextField
                                name="title"
                                className="required"
                                inputProps={{readOnly}}
                                required
                                value={ formData?.title || '' }
                                label="Disposition Group Name"
                                onChange={ (e) => onChangeEventHelper(e, setFormData) }
                            />
                            <InputLabel>Add an optional description of this disposition group</InputLabel>
                            <TextareaAutosize
                                className="standard"
                                readOnly={readOnly}
                                name="description"
                                value={ formData?.description || '' }
                                placeholder={ `Example: ${formData?.type === DispositionTypeEnum.sale? 'For sale in the CPV marketplace' : 'Sold to backgrounder'}` }
                                onChange={ (e) => onChangeEventHelper(e, setFormData) }
                            />
                            <InputLabel className="required">What kind of disposition will this be?</InputLabel>
                            <Select
                                readOnly={ readOnly }
                                name="type"
                                value={ formData?.type || 0 }
                                required
                                onChange={ (e: any) => onChangeEventHelper(e, setFormData) }
                            >
                                <MenuItem value={ 0 }>Select</MenuItem>
                                <MenuItem value={ DispositionTypeEnum.sale }>Sale</MenuItem>
                                <MenuItem value={ DispositionTypeEnum.transport }>Movement/Transport</MenuItem>
                            </Select>
                            {/* <TextField
                                name="weight"
                                inputProps={{readOnly}}
                                className="required"
                                required
                                value={ formData?.weight || '' }
                                label="Weight Range Per Head"
                                onChange={ (e) => onChangeEventHelper(e, setFormData) }
                            /> */}
                            {/* { dispType === DispositionTypeEnum.sale? <FormMoneyComponent value={ formData?.price || '' } setFormData={ setFormData } label="Price for this group" required /> : null } */}
                        </div>
                    </CpvBlockHeader>
                    
                    { formData?.type === DispositionTypeEnum.transport && 
                    <div className="disposition-list">
                        <DispositionDestinationForm
                            readOnly={ readOnly }
                            formData={ formData }
                            setGroupForm={ setFormData }
                        />
                    </div> }
                    { groups?.groups && (formData?.herd === 0 || !formData?.herd) && 
                    <div className="disposition-animals">
                    <CpvBlockHeader
                        title="Add animals from your certified groups"
                        description={ <>Below are the certified herd &amp; calving groups available to import into your disposition group.</>}
                    >
                        { groups.groups?.length > 0?
                        <GroupCheckBoxesComponent
                            groups={ groups.groups }
                            setForm={ setFormData }
                        /> : <AlertBox errorClass="danger" errorMessage="You have no certified groups available to add to this disposition group.">
                            <NavLink className={ 'corp-mui outlined rad-large size-xsmall txt-white border-white m-1' } to="/create/group/">Create</NavLink>
                        </AlertBox> }
                    </CpvBlockHeader>    
                    </div> }

                    { (hasAnimalsInGroup)?
                        <CpvBlockHeader
                            title={ `Animals (${ formData?.herd })` }
                            description="Animals that have been added to this Disposition Group"
                        >
                            <CreateButtonBlock
                                createEvent={() => setToggle(true)}
                                text={ `${readOnly? 'View' : 'Edit'} Animals` }
                            />
                        </CpvBlockHeader>
                        : null }

                    { !readOnly && (
                    <CpvBlockHeader
                        title="Activation"
                        description={formData?.type === DispositionTypeEnum.transport? undefined : "By activating the group, you will make it available for other parts of the application to interact with. You would only disable it if you weren't ready to use it yet."}
                    >
                        { formData?.type !== DispositionTypeEnum.transport && (
                        <>
                        <InputLabel className="required">Enable or disable the Disposition Group.</InputLabel>
                        <Select
                            name="status"
                            readOnly={ readOnly }
                            value={ formData?.status || 0 }
                            required
                            onChange={(e: any) => {
                                onChangeEventHelper(e, setFormData)
                            }
                        }>
                            <MenuItem value={ 0 }>Select</MenuItem>
                            <MenuItem value={ 1 }>Inactive</MenuItem>
                            <MenuItem value={ 2 }>Active</MenuItem>
                            { readOnly? <MenuItem value={ DispositionStatusEnum.archived }>Archived</MenuItem> : null }
                            { readOnly? <MenuItem value={ DispositionStatusEnum.locked }>Locked</MenuItem> : null }
                        </Select>
                        </> )}

                        { formData?.type === DispositionTypeEnum.transport && !readOnly && (
                            <div className="align-middle gapped">
                                <AlertBox
                                    errorClass="info"
                                    alert
                                    bubble={'center'}
                                >By saving the disposition, you will be marking this group as disposed which will create history on {environment.cpvChainName}. If you make this change in error, you will need to contact support to reverse it. {!formData?.ID && 'You must create the group before the option to dispose will enable.' }
                                </AlertBox>
                                <Select
                                    disabled={ !formData?.ID || !hasAnimalsInGroup }
                                    name="commit"
                                    value={ formData?.commit || 'N' }
                                    onChange={(e: any) => setFormData({ ...formData, commit: e.target.value })}
                                >
                                    <MenuItem value={ 'N' }>Select</MenuItem>
                                    <MenuItem value={ 'Y' }>Dispose</MenuItem>
                                </Select>
                            </div>
                        ) }
                    </CpvBlockHeader>)}
                    <UiNotificationsAlertsComponent />
                    <FormSubmitButtonsBlock
                        backButton={{ onClickEvent: backButtonEvent }}
                        submitButton={{
                            disabled: (formData?.type === DispositionTypeEnum.transport && !formData?.destination_id || formData?.destination_id === '0') || readOnly
                        }}
                        isSubmit
                    />
                </form> : <BootStrapSpinner />
            }
        </TemplatesCattleProofCenterBlock>
        : <BootStrapSpinner />
    )
}